// Resolve a post-login `?next=` redirect target to a SAME-ORIGIN internal path.
//
// The auth interceptor sets `?next=<current path>` when it force-signs-out a dead
// session, so re-login can return the user where they were. Because the value can
// also be attacker-crafted (anyone can hand a victim `/login?next=...`), it must be
// sanitized: resolve it against our own origin and accept it ONLY if it stays
// same-origin. This rejects absolute (`https://evil.com`), protocol-relative
// (`//evil.com`), and backslash (`/\evil.com`) URLs — the browser + react-router
// would otherwise resolve those cross-origin (classic open-redirect bypass).
//
// Returns the internal `path + search + hash` string, or null if unsafe/absent.
export function safeInternalPath(rawNext, origin) {
  try {
    if (!rawNext) return null;
    const u = new URL(rawNext, origin);
    if (u.origin === origin) return u.pathname + u.search + u.hash;
  } catch (_) {
    // malformed URL — fall through to null
  }
  return null;
}
